import type { ScreenerColumn, ScreenerSubField } from "epsm-api-types/models";

export function getDisplayTitle(
	column: ScreenerColumn,
	subfield: ScreenerSubField,
	parentName: string,
	parentTitle: string,
): { fullTitle: string; displayTitle: string } {
	const fullTitle =
		parentName === column.name
			? subfield.titleShort || subfield.title || subfield.name
			: `${parentTitle} > ${subfield.titleShort || subfield.title || subfield.name}`;

	const displayTitle = `${
		column.titleAbbreviation || column.titleShort || column.title || column.name
	} (${fullTitle})`;

	return { fullTitle, displayTitle };
}
